import blog1 from "../../src/assets/images/webp/blogs-main-1.webp";
import blog2 from "../../src/assets/images/webp/blogs-main-2.webp";
import blog3 from "../../src/assets/images/webp/blogs-main-3.webp";
export const blogsList = [
  {
    image: blog1,
    author: "admin",
    date: "Jan 04, 2025",

    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can...",
  },
  {
    image: blog2,
    author: "admin",
    date: "Jan 04, 2025",

    title: "How to make 10x more money online",
    description:
      "If you currently earn money from your blog from ads & affiliates then the most obvious way to 10x your blog income is by 10x-ing your traffic. For example, if you...",
  },
  {
    image: blog3,
    author: "admin",
    date: "Jan 04, 2025",

    title: "Caring team during the holiday season",
    description:
      "The holiday season is a time for celebration, gratitude, and, most importantly, showing that you care. As a business leader, demonstrating your appreciation...",
  },
  {
    image: blog3,
    author: "admin",
    date: "Jan 04, 2025",

    title: "Caring team during the holiday season",
    description:
      "The holiday season is a time for celebration, gratitude, and, most importantly, showing that you care. As a business leader, demonstrating your appreciation...",
  },

  {
    image: blog2,
    author: "admin",
    date: "Jan 04, 2025",

    title: "How to make 10x more money online",
    description:
      "If you currently earn money from your blog from ads & affiliates then the most obvious way to 10x your blog income is by 10x-ing your traffic. For example, if you...",
  },
  {
    image: blog1,
    author: "admin",
    date: "Jan 04, 2025",

    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can...",
  },
  {
    image: blog1,
    author: "admin",
    date: "Jan 04, 2025",

    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can...",
  },
  {
    image: blog2,
    author: "admin",
    date: "Jan 04, 2025",

    title: "How to make 10x more money online",
    description:
      "If you currently earn money from your blog from ads & affiliates then the most obvious way to 10x your blog income is by 10x-ing your traffic. For example, if you...",
  },
  {
    image: blog3,
    author: "admin",
    date: "Jan 04, 2025",

    title: "Caring team during the holiday season",
    description:
      "The holiday season is a time for celebration, gratitude, and, most importantly, showing that you care. As a business leader, demonstrating your appreciation...",
  },
  {
    image: blog3,
    author: "admin",
    date: "Jan 04, 2025",

    title: "Caring team during the holiday season",
    description:
      "The holiday season is a time for celebration, gratitude, and, most importantly, showing that you care. As a business leader, demonstrating your appreciation...",
  },

  {
    image: blog2,
    author: "admin",
    date: "Jan 04, 2025",

    title: "How to make 10x more money online",
    description:
      "If you currently earn money from your blog from ads & affiliates then the most obvious way to 10x your blog income is by 10x-ing your traffic. For example, if you...",
  },
  {
    image: blog1,
    author: "admin",
    date: "Jan 04, 2025",

    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can...",
  },
  {
    image: blog2,
    author: "admin",
    date: "Jan 04, 2025",

    title: "How to make 10x more money online",
    description:
      "If you currently earn money from your blog from ads & affiliates then the most obvious way to 10x your blog income is by 10x-ing your traffic. For example, if you...",
  },
  {
    image: blog1,
    author: "admin",
    date: "Jan 04, 2025",

    title: "5 tips for business leaders for a productive week",
    description:
      "As a business leader, the way you begin your week sets the tone for the days ahead. Adopting positive habits and strategic planning can...",
  },
];
